import React, {useState, useEffect} from 'react'

import PropTypes from 'prop-types';

const SearchBar = ({ value, onChange, debounceDelay = 300 }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      onChange(inputValue);
    }, debounceDelay);

    return () => clearTimeout(handler);
  }, [inputValue, debounceDelay, onChange]);

  return (
    <div className="mb-6 relative">
      <input
        type="text"
        placeholder="Search menu items..."
        className="w-full p-3 border border-gray-300 rounded-lg pr-10 focus:outline-none focus:ring-2 focus:ring-gold-dark"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <svg
        className="w-5 h-5 absolute right-3 top-3.5 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  debounceDelay: PropTypes.number
};

export default SearchBar